/** Next study in cohort order (wrapping) that has no disposition, excluding the
 *  current one. Returns null if none. Extracted from ReviewerPanel so the inline
 *  reviewer control bar shares the exact same advance rule. */
export function nextUnreviewedStudy<T extends { study_uid: string; disposition?: unknown }>(
  studies: T[],
  currentUid: string,
): T | null {
  const currentIdx = studies.findIndex((s) => s.study_uid === currentUid);
  if (currentIdx === -1) return null;
  for (let off = 1; off <= studies.length; off++) {
    const s = studies[(currentIdx + off) % studies.length];
    if (s.study_uid === currentUid) break; // wrapped back to current
    if (!s.disposition) return s;
  }
  return null;
}
